// Global sessionStorage key names/prefixes

export const FORM_SUBMITTED_KEY = 'asb_form_submitted';
export const FORM_STATE_SESSION_KEY_PREFIX = 'asb_form_data';
export const TRACKING_DATA_SESSION_KEY_PREFIX = 'asb_tracking_data';
